import { useEffect, useMemo, useState } from "react";
import { Button, Tooltip, Modal, Table, Tag, Input, Typography } from "antd";
import { ProjectOutlined, SearchOutlined } from "@ant-design/icons";
import { getResumenProyectos } from "../../../../services/financiero/finVistasService";
import ExportResumenProyectosButton from "./ExportResumenProyectosButton";

const { Text } = Typography;

const formatNumber = (num) => new Intl.NumberFormat("es-CO").format(Number(num) || 0);

export default function ResumenProyectosButton() {

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resumen, setResumen] = useState([]);
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    if (!open) return;

    const cargarResumen = async () => {
      try {
        setLoading(true);
        const data = await getResumenProyectos();
        setResumen(data || []);
      } catch (error) {
        console.error("Error cargando resumen de proyectos", error);
      } finally {
        setLoading(false);
      }
    };

    cargarResumen();
  }, [open]);

  const dataFiltrada = useMemo(() => {
    const texto = busqueda.trim().toLowerCase();
    const base = texto
      ? resumen.filter((r) => r.proyecto?.toLowerCase().includes(texto))
      : resumen;

    return base.map((r, i) => ({ ...r, key: r.oid_proyecto ?? i }));
  }, [resumen, busqueda]);

  const columnas = [
    {
      title: "Proyecto",
      dataIndex: "proyecto",
      ellipsis: true,
      render: (proyecto) => (
        <Tooltip title={proyecto}>
          <Text strong style={{ color: "#042956" }}>{proyecto}</Text>
        </Tooltip>
      )
    },
    {
      title: "Actas",
      dataIndex: "actas",
      width: 110,
      align: "center",
      sorter: (a, b) => Number(a.actas) - Number(b.actas),
      render: (v) => <Tag color="blue">{formatNumber(v)}</Tag>
    },
    {
      title: "Productos en stock",
      dataIndex: "productos_stock",
      width: 160,
      align: "center",
      sorter: (a, b) => Number(a.productos_stock) - Number(b.productos_stock),
      render: (v) => <Tag color="green">{formatNumber(v)}</Tag>
    },
    {
      title: "Alertas",
      dataIndex: "alertas",
      width: 110,
      align: "center",
      sorter: (a, b) => Number(a.alertas) - Number(b.alertas),
      render: (v) => (
        <Tag color={Number(v) > 0 ? "red" : "default"}>{formatNumber(v)}</Tag>
      )
    }
  ];

  return (
    <>
      <Tooltip title="Resumen por proyecto">
        <Button
          icon={<ProjectOutlined />}
          onClick={() => setOpen(true)}
          size="large"
          shape="circle"
          style={{
            background: "#042956",
            borderColor: "#042956",
            color: "#FFFFFF"
          }}
        />
      </Tooltip>

      <Modal
        title="Resumen de entregas por proyecto"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={900}
        destroyOnClose
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
            marginBottom: 16,
            flexWrap: "wrap"
          }}
        >
          <Input
            placeholder="Buscar proyecto..."
            prefix={<SearchOutlined />}
            allowClear
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            style={{ maxWidth: 320 }}
          />

          <ExportResumenProyectosButton data={dataFiltrada} />
        </div>

        <Table
          bordered
          size="small"
          columns={columnas}
          dataSource={dataFiltrada}
          loading={loading}
          pagination={{ pageSize: 10, showTotal: (total) => `Total: ${total} proyectos` }}
        />
      </Modal>
    </>
  );
}
